import { setCookie } from '../../utils/cookie_manager'
;

(function () {
  function setCountryCookie() {
    if (!$.cookie('x-country')) {
      try {
        const req = new XMLHttpRequest()
        const country = req.getResponseHeader('x-country')
        setCookie('x-country', country, 7)
      } catch (e) {}
    }
  }
  $(function () {
    setCountryCookie()
  })
})()
